import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(undefined, async (error) => {
  const original = error.config;
  if (error?.response?.status === 401 && original && !original.__retried && !String(original.url).includes("/auth/")) {
    original.__retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      await refreshing;
      return api(original);
    } catch (e) {
      /* fall through */
    }
  }
  return Promise.reject(error);
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(", ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
